<template>
  <div class="vx-col">
    <div class="fsm-card" v-if="!isAuthenticated" @click="goToHome()">
      <feather-icon icon="ArrowLeftIcon" />
    </div>
    <vx-card class="vx-card-fsm justify-center items-center">
      <div slot="no-body" class="full-page-bg-color">
        <div class="p-8 vs-con-loading__container" id="loginSubmitButton">
          <div class="vx-card__title mb-8">
            <div class="flex">
              <h4 class="mb-4 w-full">
                {{ $t("PageTitle") }}
              </h4>
            </div>
            <p>
              {{ $t("Login.GraduateTitle") }}
            </p>
          </div>

          <div v-if="!isAuthenticated && showUsernameForm">
            <ValidationObserver
              tag="form"
              ref="loginform"
              v-bind:key="'loginFormKey'"
              v-on:submit.prevent
              v-slot="{ invalid }"
            >
              <ValidationProvider
                :name="$t('Login.StudentNumber')"
                rules="required|min:3"
                v-slot="{ errors }"
              >
                <vs-input
                  icon="icon icon-user"
                  icon-pack="feather"
                  :label-placeholder="$t('Login.StudentNumber')"
                  v-model="formDataLogin.Username"
                  v-on:keyup.enter="login"
                  class="w-full no-icon-border"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>

              <ValidationProvider
                :name="$t('Login.IdentityNumber')"
                rules="required|min:3"
                v-slot="{ errors }"
              >
                <vs-input
                  type="text"
                  icon="icon icon-lock"
                  v-on:keyup.enter="login"
                  icon-pack="feather"
                  :label-placeholder="$t('Login.IdentityNumber')"
                  v-model="formDataLogin.Password"
                  class="w-full mt-6 no-icon-border mb-6"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
                
              <vs-button
                class="w-100 my-2 vs-con-loading__container"
                :disabled="invalid"
                @click="login()"
                >{{ $t("Login.LoginButton") }}</vs-button
              >
            </ValidationObserver>
          </div>

          <div v-if="isAuthenticated">
            <div class="mb-base" v-if="getReferal">
              <span class="font-semibold">{{ $t("Login.ReferalSite") }}: </span>
              <a class="font-semibold">{{ getReferal }}</a>
            </div>
            <div
              v-if="userAccounts.length && !autoLogin"
              class="p-3 bg-primary items-center justify-center"
            >
              <span class="text-sm font-semibold mb-2" style="color: white">{{
                $t("Login.SelectAccount")
              }}</span>
            </div>
            <div
              v-show="userAccounts.length && autoLogin"
              class="p-3 bg-success items-center justify-center"
            >
              <span
                class="text-sm font-semibold mb-2"
                style="color: white;font-size:0.78rem!important;"
              >
                <div
                  class="vs-con-loading__container loading-example"
                  id="login-loader"
                >
                  <!----><!---->
                  <div class="vs-loading material">
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 66 66"
                      xmlns="http://www.w3.org/2000/svg"
                      class="spinner"
                    >
                      <circle
                        fill="none"
                        stroke-width="5"
                        stroke-linecap="round"
                        cx="33"
                        cy="33"
                        r="30"
                        class="path"
                      ></circle>
                    </svg>
                  </div>
                </div>
                {{ $t("Login.RedirectWebSite") }}</span
              >
            </div>
            <div id="email-app">
              <transition-group
                name="list-enter-up"
                class="email__mails"
                tag="ul"
                appear
              >
                <li
                  class="cursor-pointer email__mail-item"
                  v-for="(user, index) in userAccounts"
                  :key="'useracc_' + index"
                  :style="{ transitionDelay: index * 0.1 + 's' }"
                  @click="goWebSite(user)"
                >
                  <div class="mail__mail-item sm:px-4 px-2 py-6">
                    <div class="flex w-full">
                      <vs-avatar
                        class="
                              sender__avatar
                              flex-shrink-0
                              mr-3
                              border-2 border-solid border-white
                            "
                        :src="user.Picture"
                        size="40px"
                      ></vs-avatar>

                      <div class="flex w-full justify-between items-center">
                        <div class="mail__details">
                          <h5 class="mb-1 font-semibold">
                            {{ user.FullName }}
                          </h5>
                          <span
                            >{{ user.StudentNumber }} /
                            {{ user.IdentityNumber }}</span
                          >
                        </div>

                        <div
                          class="
                                mail-item__meta
                                flex
                                items-center
                                justify-center
                              "
                        >
                          <feather-icon
                            icon="LogInIcon"
                            :svgClasses="['h-10 w-10 text-success']"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li
                  class="cursor-pointer email__mail-item"
                  key="useracc_logout"
                  @click="logout()"
                  :style="{
                    transitionDelay: userAccounts.length * 0.1 + 's',
                  }"
                >
                  <div class="mail__mail-item sm:px-4 px-2 py-6">
                    <div class="flex w-full">
                      <div
                        class="
                              mail-item__meta
                              flex
                              items-center
                              justify-center
                              pl-2
                            "
                      >
                        <feather-icon
                          icon="LogOutIcon"
                          :svgClasses="['h-10 w-10 text-danger']"
                          :style="{ transform: 'rotateZ(180deg)' }"
                        />
                        <h5 class="ml-4 font-semibold">
                          {{ $t("User.Logout") }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </li>
              </transition-group>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Vue from "vue";
import AuthApi from "@/api/auth";
import CountDown from "@/components/countdown";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    CountDown,
  },
  data() {
    return { 
      localProfile: {},
      autoLogin: false,
      showUsernameForm: true,
      radios1: 1,
      KVKK: true,
      formDataLogin: {
        Username: "",
        Password: "",
        RememberMe: true,
        GoogleReCaptchaResponse: "",
        Referer: "",
        ReturnUrl: "",
      },
      userAccounts: [],
      submitBusy: false,
    };
  },
  computed: {
    getReferal() {
      var url = this.$route.query.ReturnUrl;
      if (url) {
        let link = new URL(url);
        if (link && link.host) return link.host;
      }
      return "";
    },
    getReferalFullPath() {
      var url = this.$route.query.ReturnUrl;
      if (url) {
        let link = new URL(url);
        if (link && link.host) return link.href;
      }
      return "";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isAuthenticated() {
      this.localProfile;
      return this.$auth.isAuthenticated();
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "tr") return { flag: "tr", lang: "Türkçe" };
      else if (locale == "en") return { flag: "en", lang: "English" };
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },
  },
  async created() {
    if (this.$auth.isAuthenticated()) {
      this.$vs.loading({
        color: "#000",
        scale: 0.45,
      });

      var users = await AuthApi.getMyUsersForGraduate(
        {
          Referer: this.$route.query.ReturnUrl,
        },
        this
      );

      if (!users.data.error && !users.data.errors) {
        this.userAccounts = users.data.Users;
        if (this.userAccounts && this.userAccounts.length == 1)
          await this.goWebSite(this.userAccounts[0]);
        else this.$auth.logOut();
      } else this.$auth.logOut();

      setTimeout(() => {
        this.$vs.loading.close(".con-vs-loading");
      }, 100);
    }
  },
  methods: {
    goToHome() {
      this.$parent.setForm("");
    },
    async goWebSite(user) {
      if (this.autoLogin) return;
      if (user) {
        this.autoLogin = true;

        setTimeout(async () => {
          if (this.autoLogin && user.GatewayUrl) {
            try {
              var gateway = await AuthApi.gateway(user.GatewayUrl, this);
              if (gateway.data.success && this.getReferalFullPath)
                window.location.assign(this.getReferalFullPath);
            } catch {}
            this.autoLogin = false;
          } else if (this.autoLogin && !user.GatewayUrl) {
            this.$auth.hideLogin(user);
            this.$router.push("/");
          }
        }, 2000);
      }
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
    logout() {
      this.$auth.logOut();
      this.userAccounts = [];
      this.autoLogin = false;
    },
    async login() {
      const isValid = await this.$refs.loginform.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45,
      });
      try {
        this.formDataLogin.Referer = this.$route.query.ReturnUrl;
        this.$recaptcha("login").then(async (token) => {
          this.formDataLogin.GoogleReCaptchaResponse = token;
          await this.$auth.loginForGraduate(this.formDataLogin, this);
        });
      } catch {
        setTimeout(() => {
          this.$vs.loading.close(".con-vs-loading");
        }, 100);
      } finally {
        this.submitBusy = false;
      }
    },
    async handleLoginEvent(payload) {
      this.autoLogin = false;
      this.localProfile = payload;
      setTimeout(() => {
        this.$vs.loading.close("#loginSubmitButton .con-vs-loading");
      }, 100);

      if (payload.loggedIn) {
        this.$store.dispatch("auth/updateLoginGroup", "graduate");

        this.$vs.loading({
          color: "#000",
          scale: 0.45,
        });

        var users = await AuthApi.getMyUsersForGraduate(
          {
            Referer: this.$route.query.ReturnUrl,
          },
          this
        );

        if (!users.data.error && !users.data.errors) {
          this.userAccounts = users.data.Users;
          if (this.userAccounts && this.userAccounts.length == 1)
            await this.goWebSite(this.userAccounts[0]);
        } else this.$auth.logOut();

        setTimeout(() => {
          this.$vs.loading.close(".con-vs-loading");
        }, 100);
      } else this.$store.dispatch("auth/updateLoginGroup", "");
    },
  },
};
</script>

<style lang="scss">
.d-theme-dark-bg {
  border-radius: 0 3.5rem 3.5rem 0;
}
.full-page-bg-color {
  border-radius: 3.5rem;
}

.p-120 {
  padding-top: 120px !important;
  margin-bottom: 100px !important;
}

.light-shadow {
  .vx-card:hover {
    box-shadow: unset !important;
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

#login-loader {
  width: 16px;
  height: 16px;
  float: left;
  margin-right: 5px;
}
</style>

<style lang="scss">
.count-down {
  display: table;
  margin: 0 auto;
  cursor: default;
  pointer-events: none;
  .percent {
    position: relative;
    &-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #26c68a;
      font-size: 50px;
      line-height: 1;
      font-weight: bold;
      transition: all 0.5s linear;
    }
    svg {
      margin: 0 auto;
      position: relative;
      display: flex;
      circle {
        width: 100%;
        height: 100%;
        fill: none;
        stroke: #fff;
        stroke-width: 10;
        stroke-linecap: round;
        transform: translate(5px, 5px);
        &:last-child {
          stroke: #21cf90;
          transition: all 0.1s linear;
          position: absolute;
          transform: translate(5px, -5px) rotate(-90deg);
          transform-origin: center center;
        }
      }
    }
  }
}
.w-100 {
  width: 100%;
}

.vx-card-fsm {
  max-width: 423px;
  width: 100vh;
}

@media (max-width: 450px) {
  .vx-card-fsm {
    width: 100% !important;
  }
}
</style>
